/* Tabigami wishlist (saved on the shopper's device) + "Notify me" helpers */
(function () {
  'use strict';
  var KEY = 'tabigami_wishlist_v1';

  /* ---------- storage ---------- */
  function load() {
    try { var v = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(v) ? v : []; }
    catch (e) { return memory; }
  }
  var memory = [];
  function save(list) {
    memory = list;
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
  }

  function has(handle) { return load().some(function (i) { return i.handle === handle; }); }

  /* ---------- analytics (Google Analytics 4 + Shopify customer events) ---------- */
  function track(name, item) {
    var price = parseFloat(String(item.price || '').replace(/[^0-9.]/g, '')) || undefined;
    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', name, {
          currency: 'AUD', value: price,
          items: [{ item_id: item.handle, item_name: item.title, item_brand: item.vendor || undefined, price: price }]
        });
      }
    } catch (e) {}
    try {
      if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
        Shopify.analytics.publish('tabigami_' + name, { handle: item.handle, title: item.title });
      }
    } catch (e) {}
  }

  function toggle(item) {
    var list = load();
    var i = list.findIndex(function (x) { return x.handle === item.handle; });
    if (i > -1) { list.splice(i, 1); save(list); track('remove_from_wishlist', item); }
    else { item.added = Date.now(); list.unshift(item); save(list); track('add_to_wishlist', item); pop(); }
    refresh();
  }

  /* ---------- hearts ---------- */
  var HEART = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20.5s-7.5-4.6-9.3-9.2C1.4 7.9 3.6 4.5 7 4.5c2 0 3.6 1.1 5 3 1.4-1.9 3-3 5-3 3.4 0 5.6 3.4 4.3 6.8-1.8 4.6-9.3 9.2-9.3 9.2z"/></svg>';

  function handleFromUrl(href) {
    try { var m = new URL(href, location.origin).pathname.match(/\/products\/([^/?#]+)/); return m ? decodeURIComponent(m[1]) : null; }
    catch (e) { return null; }
  }

  function makeHeart(item, extraClass) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'tg-heart ' + (extraClass || '');
    b.innerHTML = HEART;
    b._tgItem = item;
    b.setAttribute('data-tg-handle', item.handle);
    return b;
  }

  function cardItem(a, img) {
    var card = a.closest('.card') || a.parentElement;
    var nameEl = card.querySelector('.name');
    var priceEl = card.querySelector('.price');
    return {
      handle: handleFromUrl(a.href),
      title: (nameEl ? nameEl.textContent : img.alt || '').trim(),
      url: a.getAttribute('href').split('?')[0],
      image: img.currentSrc || img.src,
      price: priceEl ? priceEl.textContent.trim() : ''
    };
  }

  function scanCards() {
    var added = 0;
    var imgs = document.querySelectorAll('a[href*="/products/"] img');
    imgs.forEach(function (img) {
      if (img.closest('header, .hero-collage, .tg-wl, .thumbs, .gallery, predictive-search, .predictive-search, .cart-drawer, cart-drawer, .main-image')) return;
      var wrap = img.parentElement;
      if (!wrap || wrap.querySelector(':scope > .tg-heart')) return;
      var a = img.closest('a[href*="/products/"]');
      var item = cardItem(a, img);
      if (!item.handle) return;
      if (getComputedStyle(wrap).position === 'static') wrap.style.position = 'relative';
      wrap.appendChild(makeHeart(item, 'tg-heart--card'));
      added++;
    });
    return added;
  }

  function refresh() {
    var list = load();
    document.querySelectorAll('.tg-heart').forEach(function (b) {
      var h = b.getAttribute('data-tg-handle');
      var on = list.some(function (i) { return i.handle === h; });
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.setAttribute('aria-label', on ? 'Remove from wishlist' : 'Save to wishlist');
      var lbl = b.querySelector('.tg-heart__label');
      if (lbl) lbl.textContent = on ? 'Saved to wishlist' : 'Save to wishlist';
    });
    var count = document.querySelector('.tg-wl-btn__count');
    if (count) { count.textContent = list.length; count.hidden = list.length === 0; }
    renderDrawer();
  }

  function pop() {
    var b = document.querySelector('.tg-wl-btn');
    if (!b) return;
    b.classList.remove('tg-pop'); void b.offsetWidth; b.classList.add('tg-pop');
  }

  /* ---------- header button + drawer ---------- */
  var drawer;
  function buildHeader() {
    if (document.querySelector('.tg-wl-btn')) return;
    var cart = document.querySelector('header a[href$="/cart"], header a[href*="/cart"], .header a[href*="/cart"]');
    if (!cart) return;
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'tg-wl-btn';
    b.setAttribute('aria-label', 'Open wishlist');
    b.innerHTML = HEART + '<span class="tg-wl-btn__count" hidden>0</span>';
    b.addEventListener('click', openDrawer);
    cart.parentNode.insertBefore(b, cart);

    drawer = document.createElement('div');
    drawer.className = 'tg-wl';
    drawer.hidden = true;
    drawer.innerHTML =
      '<div class="tg-wl__backdrop" data-tg-close></div>' +
      '<aside class="tg-wl__panel" role="dialog" aria-modal="true" aria-label="Your wishlist">' +
        '<div class="tg-wl__head"><h2>Your wishlist ♡</h2><button type="button" class="tg-wl__x" data-tg-close aria-label="Close">×</button></div>' +
        '<div class="tg-wl__list"></div>' +
        '<p class="tg-wl__note">Saved on this device. Sold out? Tap “Notify me” and we’ll email you when it’s back. 🐾</p>' +
      '</aside>';
    document.body.appendChild(drawer);
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-tg-close]')) closeDrawer();
      var add = e.target.closest('button[data-tg-add]');
      if (add) { addToCart(add); return; }
      var rm = e.target.closest('[data-tg-remove]');
      if (rm) {
        var h = rm.getAttribute('data-tg-remove');
        var item = load().find(function (i) { return i.handle === h; });
        if (item) toggle(item);
      }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer && !drawer.hidden) closeDrawer(); });
  }

  function esc(s) { return String(s || '').replace(/[&<>"']/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]; }); }

  function renderDrawer() {
    if (!drawer) return;
    var list = load();
    var box = drawer.querySelector('.tg-wl__list');
    if (!list.length) {
      box.innerHTML = '<div class="tg-wl__empty"><div class="tg-wl__empty-heart">♡</div><p><strong>Nothing saved yet</strong></p><p>Tap the ♡ on anything you love and it’ll wait here for you.</p></div>';
      return;
    }
    box.innerHTML = list.map(function (i) {
      return '<div class="tg-wl__item">' +
        '<a href="' + esc(i.url) + '" class="tg-wl__img">' + (i.image ? '<img src="' + esc(i.image) + '" alt="" loading="lazy">' : '') + '</a>' +
        '<div class="tg-wl__info"><a href="' + esc(i.url) + '" class="tg-wl__title">' + esc(i.title) + '</a>' +
        (i.price ? '<span class="tg-wl__price">' + esc(i.price) + '</span>' : '') +
        '<div class="tg-wl__actions"><button type="button" class="tg-wl__add" data-tg-add="' + esc(i.handle) + '" disabled>Add to cart 🛍️</button>' +
        '<a href="' + esc(i.url) + '" class="tg-wl__view">View</a></div></div>' +
        '<button type="button" class="tg-wl__rm" data-tg-remove="' + esc(i.handle) + '" aria-label="Remove ' + esc(i.title) + '">×</button>' +
      '</div>';
    }).join('');
    list.forEach(function (i) { prepareAdd(i); });
  }

  /* ---------- add to cart from the wishlist ---------- */
  var productCache = {};
  function getProduct(handle) {
    if (!productCache[handle]) {
      productCache[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('not found'); return r.json(); });
    }
    return productCache[handle];
  }
  function pickVariant(item, p) {
    if (item.variantId) {
      var v = p.variants.find(function (x) { return String(x.id) === String(item.variantId); });
      if (v) return v;
    }
    if (p.variants.length === 1) return p.variants[0];
    return null;
  }
  function prepareAdd(item) {
    var btn = drawer && drawer.querySelector('[data-tg-add="' + CSS.escape(item.handle) + '"]');
    if (!btn) return;
    getProduct(item.handle).then(function (p) {
      var v = pickVariant(item, p);
      if (!v) {
        var anyAvail = p.variants.some(function (x) { return x.available; });
        btn.outerHTML = anyAvail
          ? '<a href="' + esc(item.url) + '" class="tg-wl__add tg-wl__add--link">Choose option</a>'
          : '<a href="' + esc(item.url) + '" class="tg-wl__add tg-wl__add--soldout">Sold out · Notify me</a>';
        return;
      }
      if (!v.available) {
        btn.outerHTML = '<a href="' + esc(item.url) + '" class="tg-wl__add tg-wl__add--soldout">Sold out · Notify me</a>';
        return;
      }
      btn.setAttribute('data-variant', v.id);
      btn.disabled = false;
    }).catch(function () {
      btn.outerHTML = '<span class="tg-wl__add tg-wl__add--soldout">No longer available</span>';
    });
  }
  function updateCartCount(count) {
    var link = document.querySelector('header a[href*="/cart"]');
    if (!link) return;
    var walker = document.createTreeWalker(link, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      if (/\d+/.test(node.nodeValue)) { node.nodeValue = node.nodeValue.replace(/\d+/, count); return; }
    }
  }
  function addToCart(btn) {
    var id = btn.getAttribute('data-variant');
    if (!id) return;
    btn.disabled = true;
    btn.textContent = 'Adding…';
    fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    }).then(function (r) { if (!r.ok) throw new Error('add failed'); return fetch('/cart.js', { credentials: 'same-origin' }); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        btn.textContent = 'Added ✓';
        btn.classList.add('is-added');
        if (/\/cart\/?$/.test(location.pathname)) setTimeout(function () { location.reload(); }, 600);
      })
      .catch(function () { btn.disabled = false; btn.textContent = 'Try again'; });
  }

  /* ---------- cart page: "Save for later" moves an item to the wishlist ---------- */
  function setupCart() {
    if (!/\/cart\/?$/.test(location.pathname)) return;
    document.querySelectorAll('.line-item').forEach(function (row) {
      var rm = row.querySelector('.remove-btn');
      var link = row.querySelector('a[href*="/products/"]');
      if (!rm || !link || row.querySelector('.tg-save-later')) return;
      var url = link.getAttribute('href');
      var variant = null;
      try { variant = new URL(url, location.origin).searchParams.get('variant'); } catch (e) {}
      var img = row.querySelector('img');
      var priceEl = row.querySelector('.price');
      var vendorEl = row.querySelector('.vendor');
      var item = {
        handle: handleFromUrl(url), title: link.textContent.trim(), url: url.split('?')[0],
        image: img ? (img.currentSrc || img.src) : '', price: priceEl ? priceEl.textContent.trim() : '',
        vendor: vendorEl ? vendorEl.textContent.trim() : '', variantId: variant
      };
      if (!item.handle) return;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'tg-save-later';
      b.innerHTML = HEART + '<span>Save for later</span>';
      b.addEventListener('click', function () {
        if (!has(item.handle)) toggle(item);
        b.disabled = true;
        b.querySelector('span').textContent = 'Saved ♡';
        setTimeout(function () { rm.click(); }, 350);
      });
      rm.parentNode.insertBefore(b, rm.nextSibling);
    });
  }

  function openDrawer() { if (!drawer) return; renderDrawer(); drawer.hidden = false; document.documentElement.classList.add('tg-wl-open'); }
  function closeDrawer() { if (!drawer) return; drawer.hidden = true; document.documentElement.classList.remove('tg-wl-open'); }

  /* ---------- clicks on hearts ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('.tg-heart');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    var item = b._tgItem;
    if (!item) {
      item = {
        handle: b.getAttribute('data-tg-handle'), title: b.getAttribute('data-title'), url: b.getAttribute('data-url'),
        image: b.getAttribute('data-image'), price: b.getAttribute('data-price'), vendor: b.getAttribute('data-vendor')
      };
    }
    toggle(item);
  }, true);

  /* ---------- product page: heart + "Notify me" ---------- */
  function isProductPage() {
    var m = document.querySelector('main[data-template]');
    return m && /^product/.test(m.getAttribute('data-template') || '');
  }

  function buildPdp() {
    if (!isProductPage()) return;
    var h1 = document.querySelector('main h1');
    var handle = handleFromUrl(location.href);
    if (!h1 || !handle || document.querySelector('.tg-heart--pdp')) return;
    var section = h1.closest('section') || document;
    var img = section.querySelector('.main-image img, img');
    var priceEl = section.querySelector('.price');
    var vendorEl = section.querySelector('.vendor');
    var item = {
      handle: handle, title: h1.textContent.trim(), url: location.pathname,
      image: img ? (img.currentSrc || img.src) : '', price: priceEl ? priceEl.textContent.trim() : '',
      vendor: vendorEl ? vendorEl.textContent.trim() : ''
    };
    var b = makeHeart(item, 'tg-heart--pdp');
    b.insertAdjacentHTML('beforeend', '<span class="tg-heart__label">Save to wishlist</span>');
    var anchor = priceEl && priceEl.parentNode === h1.parentNode ? priceEl : h1;
    anchor.parentNode.insertBefore(b, anchor.nextSibling);
    setupNotify(section, item);
  }

  function setupNotify(section, item) {
    var addBtn = section.querySelector('.add-btn');
    var productForm = section.querySelector('form[action*="/cart/add"]');
    if (!addBtn || !productForm) return;
    var pending = null;
    try { pending = sessionStorage.getItem('tg_notify_pending'); sessionStorage.removeItem('tg_notify_pending'); } catch (e) {}
    var posted = /customer_posted=true/.test(location.search) && pending === item.handle;
    var box = document.createElement('div');
    box.className = 'tg-notify';
    box.hidden = true;
    var tags = 'newsletter,notify,notify-' + item.handle;
    if (posted) {
      box.innerHTML = '<p class="tg-notify__title">You’re on the list! 🐾</p>' +
        '<p class="tg-notify__text">We’ll email you as soon as it’s back in stock. Keep an eye on your inbox (and your spam folder, just in case).</p>';
    } else {
      box.innerHTML =
        '<form method="post" action="/contact#tg-notify" accept-charset="UTF-8" class="tg-notify__form" id="tg-notify">' +
          '<input type="hidden" name="form_type" value="customer"><input type="hidden" name="utf8" value="✓">' +
          '<input type="hidden" name="contact[tags]" value="' + esc(tags) + '">' +
          '<p class="tg-notify__title">Sold out for now 🐾</p>' +
          '<p class="tg-notify__text">Pop in your email and we’ll let you know as soon as it’s back.</p>' +
          '<div class="tg-notify__row">' +
            '<input type="email" name="contact[email]" required autocomplete="email" placeholder="you@example.com" class="tg-notify__input" aria-label="Email">' +
            '<button type="submit" class="tg-notify__btn">Notify me</button>' +
          '</div>' +
          '<p class="tg-notify__small">You’ll also get Tabigami news and new arrivals. Unsubscribe anytime.</p>' +
        '</form>';
    }
    productForm.parentNode.insertBefore(box, productForm.nextSibling);

    function sync() {
      var soldOut = addBtn.disabled && /sold out/i.test(addBtn.textContent);
      box.hidden = !(soldOut || posted);
    }
    new MutationObserver(sync).observe(addBtn, { attributes: true, childList: true, characterData: true, subtree: true });
    sync();
    if (posted) setTimeout(function () { box.scrollIntoView({ block: 'center' }); }, 300);

    var form = box.querySelector('form');
    if (!form) return;
    var sent = false;
    form.addEventListener('submit', function (e) {
      if (sent) return;
      e.preventDefault();
      var email = form.querySelector('input[type="email"]').value;
      var opts = Array.prototype.map.call(section.querySelectorAll('.opt-val'), function (s) { return s.textContent.trim(); }).filter(Boolean).join(' / ');
      var body = 'Back-in-stock request\n' +
        'Product: ' + item.title + (opts ? '\nOption: ' + opts : '') +
        '\nLink: ' + location.origin + location.pathname + location.search +
        '\nEmail: ' + email;
      var fd = new FormData();
      fd.append('form_type', 'contact');
      fd.append('utf8', '✓');
      fd.append('contact[name]', 'Notify me request');
      fd.append('contact[email]', email);
      fd.append('contact[body]', body);
      try { sessionStorage.setItem('tg_notify_pending', item.handle); } catch (e2) {}
      track('notify_me_signup', item);
      var done = function () { if (sent) return; sent = true; HTMLFormElement.prototype.submit.call(form); };
      var timer = setTimeout(done, 3000);
      fetch('/contact', { method: 'POST', body: fd, credentials: 'same-origin' })
        .catch(function () {})
        .then(function () { clearTimeout(timer); done(); });
    });
  }

  /* ---------- start ---------- */
  function init() {
    buildHeader();
    scanCards();
    buildPdp();
    setupCart();
    refresh();
    var t;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(function () { if (scanCards()) refresh(); }, 250); })
      .observe(document.body, { childList: true, subtree: true });
    window.addEventListener('storage', function (e) { if (e.key === KEY) refresh(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
